import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/public_api";
import { PedidoService } from "src/app/core/services/pedido-service";
import Swal from "sweetalert2";
import { ActivatedRoute, Router } from "@angular/router";
import { InitProvider } from "src/app/core/services/init-provider";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { OrderClient } from "src/app/core/entities/orderClient";
import { UsuarioService } from "src/app/core/services/usuario-service";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { LogService } from "src/app/core/services/log-service";
import { formatDate, Location } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { distinctUntilChanged, filter } from "rxjs/operators";

declare var $: any;

@Component({
  selector: "app-page-new-order",
  templateUrl: "./page-new-order.component.html",
  styleUrls: ["./page-new-order.component.css"],
})
export class PageNewOrderComponent implements OnInit {
  SITE: ConfiguracoesSite;
  abrePedidoEmGrupo: boolean;

  public error: Boolean = false;
  public errorMsg: String[] = [];
  public form: FormGroup;
  isCopy: boolean = false
  term: string = "";
  tipoSelecionado: any;
  noResult = false;
  selectedCliente: any;
  listCliente: any = [];
  tabelas: any = [];
  public dateFormat = $localize`DD/MM/YYYY`
  tabelasUsuario: any = [];
  tabelasCliente: any = [];
  tabelasFilial: any = [];
  pedidoTiposUsuario: any = [];
  clienteDetail: any = {};

  filiais: any = [];
  filial_Estoque: any = [];
  errorClienteTabela = false;
  errorClienteBloqueado = false;

  dataEntregaMinDate: Date;
  dataEntregaDaysDisable = [];
  clienteIdErp = {};
  pedidoOriginal;
  erroMensagemBloqueio: any;
  cidades?: any;

  /**
   * Enquanto true, ignora (change) da filial — evita selecionaFilial → openTabelas()
   * apagando this.tabelas ao dar setValue programático ao trocar de cliente no badge.
   */
  private aplicandoDadosCliente = false;

  /** Cache de getTabelas por cliente + filial (evita novo GET a cada clique no badge). */
  private tabelasPorClienteFilial = new Map<string, any[]>();

  private filialValueSub?: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private initProvider: InitProvider,
    private usuarioService: UsuarioService,
    private localeService: BsLocaleService,
    private pedidoService: PedidoService,
    private logService: LogService,
    private activeRoute: ActivatedRoute,
    public toastService: ToastrService,
    private location: Location
  ) {
    this.selectedCliente = {}
    this.isCopy = this.router.url === "/copia-pedido"
    this.SITE = Configuracoes.SITE;
    this.abrePedidoEmGrupo = Configuracoes.abrePedidoEmGrupo
    this.dataEntregaMinDate = new Date();
    this.tipoSelecionado = "";

    if (
      this.dataEntregaMinDate.getHours() > this.SITE.dataEntregaHorarioLimite
    ) {
      this.dataEntregaMinDate.setDate(
        this.dataEntregaMinDate.getDate() +
        1 +
        this.SITE.dataEntregaCarenciaPrazo
      );
    } else {
      this.dataEntregaMinDate.setDate(
        this.dataEntregaMinDate.getDate() + this.SITE.dataEntregaCarenciaPrazo
      );
    }
    this.dataEntregaDaysDisable = JSON.parse(
      "[" + this.SITE.dataEntregaDiasDesabilitados + "]"
    );
    this.localeService.use("pt-custom");

    // this.filiais = initProvider.filiais;
    this.form = this.formBuilder.group({
      tabela: ["", Validators.required],
      pedidoTipo: ["", Validators.required],
      filialEstoque: [""],
    });
    if (this.SITE.mostraDataEntrega) {
      this.form.addControl(
        "dataEntrega",
        new FormControl("", [Validators.required])
      );
    }
    if (this.filiais.length === 1) {
      this.form.addControl(
        "filial",
        new FormControl(this.filiais[0].id, [Validators.required])
      );
      this.selecionaFilial(this.filiais[0].id);
    } else {
      this.form.addControl(
        "filial",
        new FormControl("", [Validators.required])
      );
    }

    this.pedidoOriginal = this.router.getCurrentNavigation().extras.state;

    if (this.pedidoOriginal) {
      for (let cliente_ in this.pedidoOriginal.clientes) {
        this.selecionaCliente(this.pedidoOriginal.clientes[cliente_].cliente);
        $("#cliente").val("");
      }

      this.form.controls["tabela"].setValue(this.pedidoOriginal.tabela.id);
      this.form.controls["pedidoTipo"].setValue(this.pedidoOriginal.tipo.id);

      if (
        this.pedidoOriginal.dataEntrega &&
        this.pedidoOriginal.dataEntrega != null
      )
        this.form.controls["dataEntrega"].setValue(
          this.pedidoOriginal.dataEntrega
        );
    }
  }

  results: string[] = [];

  buscandoClientes: boolean = false;

  /** Enquanto busca detalhes (getClientesId) após escolher um cliente na lista. */
  clienteDetalheCarregando = false;

  get clienteSelecionado(): boolean {
    return !!this.selectedCliente && !!this.selectedCliente.id;
  }

  get clienteIntegrado(): boolean {
    const c: any = this.selectedCliente;
    if (!c || !c.id) {
      return true;
    }
    return Array.isArray(c.enderecos) && c.enderecos.length > 0;
  }

  private static readonly BUSCA_MIN = 2;

  private debounceTimer: any;
  private lastParams: string = "";

  private debounceBuscarClientes(params: { busca: string; id_usuario: any }) {
    clearTimeout(this.debounceTimer);
    this.buscandoClientes = true;
    this.debounceTimer = setTimeout(() => {
      const p = JSON.stringify(params);
      if (p !== this.lastParams) {
        this.lastParams = p;
        this.usuarioService.getClientes(
          params,
          function (resp) {
            this.results = resp;
            this.buscandoClientes = false;
          }.bind(this)
        );
      } else {
        this.buscandoClientes = false;
      }
    }, 0);
  }

  /** Automático: só a cada 4 caracteres (4, 8, 12…). Botão Buscar:4+ caracteres. */
  searchFunction = async (value: string, forceSearch = false) => {
    const v = (value ?? "").trim();
    if (!v) {
      this.results = [];
      this.buscandoClientes = false;
      return;
    }
    if (!forceSearch && v.length < PageNewOrderComponent.BUSCA_MIN) {
      this.buscandoClientes = false;
      return;
    }
    this.debounceBuscarClientes({ busca: v, id_usuario: this.initProvider.usuario.id });
  };

  handleSelection = (value: string) => {
    this.selecionaCliente(value);
    this.results = []
  };

  handleSelectionCopy = (value: string) => {
    this.selecionaClienteCopy(value);
    this.results = []
  };

  select(param) {
    this.clienteIdErp[this.selectedCliente.id] = param;
  }
  onSubmit() {
    if (this.selectedCliente.cidades.id === null) {
      let msg = $localize`Cidade não encontrada`;
      this.toastService.warning(msg, "", {
        timeOut: 4000,
      });
      return;
    }
    if (!this.listCliente.length) {
      this.error = true;
      this.errorMsg.push($localize`Selecione um ou mais clientes!`);
      return;
    }

    if (this.tabelas.length < 1) {
      // this.error = true;
      // this.errorMsg.push("Cliente sem tabela de preço!");
      this.toastService.warning($localize`Cliente sem ${this.SITE.labelTabela} de preço!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      // return;
    } else if (this.form.get("tabela").value === "") {
      this.toastService.warning($localize`Selecione uma ${this.SITE.labelTabela}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
    }

    if (this.filiais.length < 1) {
      // this.error = true;
      // this.errorMsg.push("Cliente sem filial!");
      this.toastService.warning($localize`Cliente sem ${this.SITE.labelFilial}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      // return;
    } else if (this.form.get("filial").value === "") {
      this.toastService.warning($localize`Selecione uma ${this.SITE.labelFilial}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
    }

    if (this.pedidoTiposUsuario.length < 1) {
      // this.error = true;
      // this.errorMsg.push("Cliente sem filial!");
      this.toastService.warning($localize`Cliente sem ${this.SITE.labelFilial}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      // return;
    } else if (this.form.get("pedidoTipo").value === "") {
      this.toastService.warning($localize`Selecione uma um ${this.SITE.labelPedidoTipo}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
    }

    // if (!this.form.valid) {
    //   this.error = true;
    //   this.errorMsg = "Confira o formulário corretamente!";
    //   return;
    // }

    if (this.clienteIdErp[this.selectedCliente.id] === "") {
      this.toastService.warning($localize`Escolha um endereço`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
    }

    if (
      (this.filial_Estoque === "" || this.filial_Estoque.length === 0) &&
      this.initProvider.usaFilialEstoque
    ) {
      this.toastService.warning($localize`Cliente sem filial de estoque`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      return;
    } else if (
      this.form.get("filialEstoque").value === "" &&
      this.initProvider.usaFilialEstoque
    ) {
      this.toastService.warning($localize`Selecione uma filial de estoque`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      return;
    }

    if (
      this.form.valid &&
      !this.pedidoService.loading &&
      this.clienteIdErp[this.selectedCliente.id] !== ""
    ) {
      let filialId = this.form.get("filial").value;
      let tabelaId = this.form.get("tabela").value;
      let pedidoTipoId = this.form.get("pedidoTipo").value;
      let filialEstoqueId = this.form.get("filialEstoque").value;
      let pedidoClientes: OrderClient[] = [];
      let dataEntrega = "";
      if (this.SITE.mostraDataEntrega) {
        dataEntrega = formatDate(
          this.form.get("dataEntrega").value,
          "dd/MM/yyyy",
          "en"
        );
      }
      this.listCliente.forEach((c) => {
        pedidoClientes.push({
          idEnderecoErp: this.clienteIdErp[c.id],
          cliente: c.id,
          quantidade: 0,
          subtotal: 0,
          impostos: 0,
          acrescimo: 0,
          acrescimoPercent: 0,
          desconto: 0,
          descontoPercent: 0,
          total: 0,
        });
      });
      let formPedido = {
        clientes: pedidoClientes,
        filial: filialId,
        tabela: tabelaId,
        tipo: pedidoTipoId,
        dataEntrega: dataEntrega,
        filialEstoque: this.initProvider.usaFilialEstoque
          ? filialEstoqueId
          : null,
      };
      this.pedidoService.abrir(
        formPedido,
        function (resp) {
          if (!this.pedidoService.parseV2PedidoSaveResponse(resp)) {
            this.toastService.warning(
              $localize`Não foi possível confirmar o pedido aberto. Verifique a resposta da API.`,
              $localize`Pedido`,
              { timeOut: 5000 }
            );
            return;
          }
          Swal.fire($localize`Pedido`, $localize`Aberto com sucesso!`, "success");

          if (
            this.pedido !== undefined &&
            Configuracoes.modoVisualizacaoCatalogo
          )
            window.localStorage.setItem(
              "visualizacaoModo",
              Configuracoes.modoVisualizacaoCatalogo
            );
          /* select + /catalogo: PedidoService.handleV2PedidoAbrirSuccess */
        }.bind(this),
        function (error) {
          if (error.status == 403) {
            //403 Forbidden
            let msg = $localize`Usuário não autenticado`;
            this.toastService.info(msg, "", {
              timeOut: 4000,
            });
            window.location.href = "/login";
            return
          }
          if (error.status) {
            this.toastService.error(error.error.detail, $localize`Produto`, {
              positionClass: "toast-bottom-left",
            });
          }
          let obj = JSON.parse(error._body);
          if (obj && obj.msg) {
            this.error = true;
            this.errorMsg = obj.msg;
          }
          if (obj && obj.detail) {
            this.error = true;
            this.errorMsg = [obj.detail];
          }
        }.bind(this)
      );
    }
  }

  async onCopySubmit() {
    try {
      // 🔹 Helper para mostrar warning e retornar falso
      const warn = (msg: string, title: string = $localize`Cliente`) => {
        this.toastService.warning(msg, title, { positionClass: "toast-bottom-right", timeOut: 4000 });
        return false;
      };

      // 🔹 Validações iniciais
      // console.log(this.selectedCliente)
      // return
      if (!this.selectedCliente?.cidade?.id) {
        // 🔹 tenta localizar cidade pelo cliente
        // const cidadeEncontrada = this.cidades?.find(c => c.id === this.selectedCliente?.cidadeId);

        if (!this.selectedCliente?.cidades?.id) {
          return warn($localize`Cidade não encontrada`);
        }
      }


      if (!this.listCliente.length) return warn($localize`Selecione um ou mais clientes!`);

      if (this.tabelas.length < 1) {
        warn($localize`Cliente sem ${this.SITE.labelTabela} de preço!`);
      } else if (!this.form.get("tabela")?.value) {
        return warn($localize`Selecione uma ${this.SITE.labelTabela}!`);
      }

      if (this.filiais.length < 1) {
        warn($localize`Cliente sem ${this.SITE.labelFilial}!`);
      } else if (!this.form.get("filial")?.value) {
        return warn($localize`Selecione uma ${this.SITE.labelFilial}!`);
      }

      if (this.pedidoTiposUsuario.length < 1) {
        warn($localize`Cliente sem ${this.SITE.labelPedidoTipo}!`);
      } else if (!this.form.get("pedidoTipo")?.value) {
        return warn($localize`Selecione um ${this.SITE.labelPedidoTipo}!`);
      }

      if (!this.clienteIdErp[this.selectedCliente.id]) {
        return warn($localize`Escolha um endereço`);
      }

      if (this.initProvider.usaFilialEstoque) {
        if (!this.filial_Estoque?.length) {
          return warn($localize`Cliente sem filial de estoque`);
        }
        if (!this.form.get("filialEstoque")?.value) {
          return warn($localize`Selecione uma filial de estoque`);
        }
      }

      if (!this.form.valid || this.pedidoService.loading) {
        return warn($localize`Confira o formulário corretamente!`);
      }

      // 🔹 Monta objeto pedido
      const pedidoClientes: OrderClient[] = this.listCliente.map(c => ({
        idEnderecoErp: this.clienteIdErp[c.id],
        cliente: c.id,
        quantidade: this.pedidoService.pedidoCopy.clientes[0].quantidade,
        subtotal: this.pedidoService.pedidoCopy.clientes[0].subtotal,
        impostos: this.pedidoService.pedidoCopy.clientes[0].impostos,
        acrescimo: this.pedidoService.pedidoCopy.clientes[0].acrescimo,
        acrescimoPercent: this.pedidoService.pedidoCopy.clientes[0].acrescimoPercent,
        desconto: this.pedidoService.pedidoCopy.clientes[0].desconto,
        descontoPercent: this.pedidoService.pedidoCopy.clientes[0].descontoPercent,
        total: this.pedidoService.pedidoCopy.clientes[0].total,
      }));
      // console.log(this.listCliente)
      // console.log(this.pedidoService.pedidoCopy)
      // return

      const formPedido = {
        id: this.pedidoService.pedidoCopy.id,
        itens: this.pedidoService.pedidoCopy.itens
          .filter(
            i => i.cliente === this.pedidoService.pedidoCopy.clientes[this.pedidoService.index].cliente.id
          ),
        clientes: pedidoClientes,
        filial: this.form.get("filial")?.value,
        tabela: this.form.get("tabela")?.value,
        tipo: this.form.get("pedidoTipo")?.value,
        dataEntrega: this.SITE.mostraDataEntrega
          ? formatDate(this.form.get("dataEntrega")?.value, "dd/MM/yyyy", "en")
          : "",
        quatidade: this.pedidoService.pedidoCopy.quantidade,
        subtotal: this.pedidoService.pedidoCopy.subtotal,
        impostos: this.pedidoService.pedidoCopy.impostos,
        acrescimo: this.pedidoService.pedidoCopy.acrescimo,
        desconto: this.pedidoService.pedidoCopy.desconto,
        total: this.pedidoService.pedidoCopy.total,
        filialEstoque: this.initProvider.usaFilialEstoque
          ? this.form.get("filialEstoque")?.value
          : null,
      };
      // 🔹 Chamada ao serviço com tratamento de erro
      // return
      this.pedidoService.abrirCopy(
        formPedido,
        (resp) => {
          if (!this.pedidoService.parseV2PedidoSaveResponse(resp)) {
            this.toastService.warning(
              $localize`Não foi possível confirmar o pedido aberto. Verifique a resposta da API.`,
              $localize`Pedido`,
              { timeOut: 5000 }
            );
            return;
          }
          Swal.fire($localize`Pedido`, $localize`Aberto com sucesso!`, "success");

          if (Configuracoes.modoVisualizacaoCatalogo) {
            window.localStorage.setItem("visualizacaoModo", Configuracoes.modoVisualizacaoCatalogo);
          }
          /* select + /catalogo: PedidoService.handleV2PedidoAbrirSuccess */
        },
        (error) => {
          if (error.status === 403) {
            this.toastService.info($localize`Usuário não autenticado`, "", { timeOut: 4000 });
            window.location.href = "/login";
            return;
          }

          if (error.status && error.error?.detail) {
            this.toastService.error(error.error.detail, $localize`Produto`, { positionClass: "toast-bottom-left" });
          }

          try {
            const obj = JSON.parse(error._body);
            if (obj?.msg) {
              this.error = true;
              this.errorMsg = obj.msg;
            } else if (obj?.detail) {
              this.error = true;
              this.errorMsg = [obj.detail];
            }
          } catch {
            this.toastService.error($localize`Erro inesperado no servidor`, $localize`Pedido`);
          }
        }
      );
    } catch (e) {
      this.toastService.error($localize`Erro inesperado`, $localize`Pedido`);
      console.error("Erro onCopySubmit:", e);
    }
  }


  onSelect(event: TypeaheadMatch): void {
    const item = event.item;
    delete item.bloqueiaPedidos;
    this.selecionaCliente(event.item);
  }

  /** Cliente já passou por getClientesId (ex.: badge em listCliente) — evita nova chamada à API. */
  /** Detalhe suficiente para pular getClienteID; tabelas vêm só de getTabelas. */
  private clienteDetalhadoEmMemoria(c: any): boolean {
    return (
      c != null &&
      typeof c === "object" &&
      Array.isArray(c.filiais) &&
      Array.isArray(c.filial_estoque) &&
      Array.isArray(c.enderecos)
    );
  }

  private chaveCacheTabelas(
    clienteId: number,
    filialId: number | string
  ): string {
    return `${clienteId}_${String(filialId)}`;
  }

  /** Lista do select: somente getTabelas; usa cache quando já buscou para (cliente, filial). */
  private aplicarListaTabelasDoServico(
    respTab: any[],
    preferTabelaId?: number | string
  ): void {
    const list = Array.isArray(respTab) ? respTab : [];
    this.tabelas = list;
    const prefer =
      preferTabelaId != null && `${preferTabelaId}` !== ""
        ? list.find((t) => String(t.id) === String(preferTabelaId))
        : null;
    if (prefer) {
      this.form.controls.tabela.setValue(prefer.id, { emitEvent: false });
    } else if (list.length === 1) {
      this.form.controls.tabela.setValue(list[0].id, { emitEvent: false });
    } else {
      this.form.controls.tabela.setValue("", { emitEvent: false });
    }
  }

  private carregarTabelasPreco(
    clienteId: number,
    filialId: number | string,
    preferTabelaId?: number | string
  ): void {
    const key = this.chaveCacheTabelas(clienteId, filialId);
    const cached = this.tabelasPorClienteFilial.get(key);
    if (cached) {
      this.aplicarListaTabelasDoServico(cached.slice(), preferTabelaId);
      return;
    }
    this.tabelas = [];
    this.form.controls.tabela.setValue("", { emitEvent: false });
    this.usuarioService.getTabelas(
      clienteId,
      (respTab: any[]) => {
        const list = Array.isArray(respTab) ? respTab.slice() : [];
        this.tabelasPorClienteFilial.set(key, list);
        this.aplicarListaTabelasDoServico(list, preferTabelaId);
      },
      filialId
    );
  }

  private invalidarCacheTabelasCliente(clienteId: number): void {
    const prefix = `${clienteId}_`;
    for (const k of this.tabelasPorClienteFilial.keys()) {
      if (k.startsWith(prefix)) {
        this.tabelasPorClienteFilial.delete(k);
      }
    }
  }

  /** Atualiza o select de tipo de pedido usando lista já carregada (sem getPedidoTipos). */
  private aplicarPedidoTipoDaMemoria(): void {
    if (this.pedidoTiposUsuario?.length === 1) {
      this.form.controls.pedidoTipo.setValue(this.pedidoTiposUsuario[0].id);
    } else {
      this.form.controls.pedidoTipo.setValue("");
    }
  }

  selecionaCliente(cliente: any) {
    this.errorClienteTabela = false;
    this.errorClienteBloqueado = false;
    if (cliente.bloqueiaPedidos) {
      this.errorClienteBloqueado = true;
    }

    this.clienteIdErp[cliente.id] = cliente.idEnderecoErp
      ? cliente.idEnderecoErp + ""
      : "";

    const aplicarCliente = (resp: any, daMemoria: boolean) => {
      this.aplicandoDadosCliente = true;
      try {
        this.errorClienteBloqueado = resp.bloqueiaPedidos;
        if (resp.bloqueiaPedidos) {
          this.erroMensagemBloqueio = resp.mensagemBloqueio;
        }
        if (daMemoria) {
          this.aplicarPedidoTipoDaMemoria();
        } else {
          this.usuarioService.getPedidoTipos(
            function (respTipos) {
              this.pedidoTiposUsuario = respTipos;
              if (this.pedidoTiposUsuario.length == 1) {
                this.form.controls.pedidoTipo.setValue(
                  this.pedidoTiposUsuario[0].id
                );
              } else {
                this.form.controls.pedidoTipo.setValue("");
              }
            }.bind(this)
          );
        }

        this.filiais = resp.filiais;
        this.filial_Estoque = resp.filial_estoque;
        this.setSelectedCliente(resp);
        this.addCliente(resp);

        const filialUnica =
          resp.filiais.length < 2 && resp.filiais.length > 0;

        if (filialUnica) {
          const filialId = resp.filiais[0].id;
          this.form.controls.filial.setValue(filialId, {
            emitEvent: false,
          });
          this.carregarTabelasPreco(this.selectedCliente.id, filialId);
        } else {
          this.form.controls.filial.setValue("", { emitEvent: false });
          this.tabelas = [];
          this.form.controls.tabela.setValue("", { emitEvent: false });
        }
        if (resp.filial_estoque.length < 2 && resp.filial_estoque.length > 0) {
          this.form.controls.filialEstoque.setValue(resp.filial_estoque[0].id, {
            emitEvent: false,
          });
        } else {
          this.form.controls.filialEstoque.setValue("", { emitEvent: false });
        }
      } finally {
        queueMicrotask(() => {
          this.aplicandoDadosCliente = false;
          this.clienteDetalheCarregando = false;
        });
      }
    };

    if (this.clienteDetalhadoEmMemoria(cliente)) {
      aplicarCliente(cliente, true);
      /* openTabelas sobrescreve this.tabelas com tabelasUsuario e some o select — não usar aqui. */
    } else {
      /* Não chamar openTabelas() aqui: usa tabelasUsuario e faz o select “aparecer” com N opções;
       * ao chegar a resposta com 1 tabela, *ngIf antigo (length > 1) escondia o campo. */
      this.clienteDetalheCarregando = true;
      this.form.controls.tabela.setValue("", { emitEvent: false });
      this.tabelas = [];
      this.usuarioService.getClientesId(
        {
          id_cliente: cliente.id,
          id_usuario: this.initProvider.usuario.id,
        },
        (r) => aplicarCliente(r, false)
      );
    }
    $("#cliente").val("");
  }

  selecionaClienteCopy(cliente: any) {
    this.errorClienteTabela = false;
    this.errorClienteBloqueado = false;
    if (cliente.bloqueiaPedidos) {
      this.errorClienteBloqueado = true;
    }

    this.clienteIdErp[cliente.id] = cliente.idEnderecoErp
      ? cliente.idEnderecoErp + ""
      : "";

    const aplicarClienteCopy = (resp: any) => {
      this.errorClienteBloqueado = resp.bloqueiaPedidos;
      if (resp.bloqueiaPedidos) {
        this.erroMensagemBloqueio = resp.mensagemBloqueio;
      }
      this.setSelectedCliente(resp);
      this.addCliente(resp);
      const filialUnica =
        resp.filiais.length < 2 && resp.filiais.length > 0;
      if (filialUnica) {
        const filialId = resp.filiais[0].id;
        this.form.controls.filial.setValue(filialId, { emitEvent: false });
        this.carregarTabelasPreco(this.selectedCliente.id, filialId);
      } else {
        this.form.controls.filial.setValue("", { emitEvent: false });
        this.tabelas = [];
        this.form.controls.tabela.setValue("", { emitEvent: false });
      }
      this.clienteDetalheCarregando = false;
    };

    if (this.clienteDetalhadoEmMemoria(cliente)) {
      aplicarClienteCopy(cliente);
    } else {
      this.clienteDetalheCarregando = true;
      this.form.controls.tabela.setValue("", { emitEvent: false });
      this.tabelas = [];
      this.usuarioService.getClientesId(
        {
          id_cliente: cliente.id,
          id_usuario: this.initProvider.usuario.id,
        },
        aplicarClienteCopy
      );
    }
    $("#cliente").val("");
  }

  setSelectedCliente(c: any) {
    if (c.enderecos.length === 1) {
      this.clienteIdErp[c.id] = c.enderecos[0].id;
    }
    this.selectedCliente = c;
  }

  excluiCliente(c: any) {
    for (var i = 0; i < this.listCliente.length; i++) {
      if (this.listCliente[i].id == c.id) {
        this.listCliente.splice(i, 1);
        break;
      }
    }
    if (this.selectedCliente && this.selectedCliente.id == c.id) {
      if (this.listCliente.length) {
        this.selectedCliente = this.listCliente[this.listCliente.length - 1];
      } else {
        this.tabelasCliente = [];
        this.selectedCliente = null;
        this.clienteDetalheCarregando = false;
        this.openTabelas();
      }
    }
    this.invalidarCacheTabelasCliente(c.id);
    this.filiais = [];
    this.tabelasFilial = [];
  }

  excluiClienteCopy(c: any) {
    for (var i = 0; i < this.listCliente.length; i++) {
      if (this.listCliente[i].id == c.id) {
        this.listCliente.splice(i, 1);
        break;
      }
    }
    if (this.selectedCliente && this.selectedCliente.id == c.id) {
      if (this.listCliente.length) {
        this.selectedCliente = this.listCliente[this.listCliente.length - 1];
      } else {
        this.selectedCliente = null;
        this.clienteDetalheCarregando = false;
        this.openTabelas();
      }
    }
    this.invalidarCacheTabelasCliente(c.id);
  }

  addCliente(c: any) {
    for (var i = 0; i < this.listCliente.length; i++) {
      if (this.listCliente[i].id == c.id) return;
    }
    this.listCliente.push(c);
  }
  selectTipo(e) {
    localStorage.setItem("tipoPedidoPre", e.target.value);
  }
  selecionaFilial(idFilial) {
    if (this.aplicandoDadosCliente) {
      return;
    }
    if (idFilial === "" || idFilial == null) {
      this.tabelas = [];
      this.form.controls.tabela.setValue("", { emitEvent: false });
      return;
    }
    let filial: any;
    for (var i = 0; i < this.filiais.length; i++) {
      if (this.filiais[i].id == idFilial) {
        filial = this.filiais[i];
      }
    }
    if (!filial) return;

    this.carregarTabelasPreco(this.selectedCliente.id, idFilial);
  }

  openTabelas() {
    this.form.controls.tabela.setValue("");
    if (this.tabelasFilial.length) {
      this.tabelas = this.tabelasFilial;
    } else if (this.tabelasCliente.length) {
      this.tabelas = this.tabelasCliente;
    } else {
      this.tabelas = this.tabelasUsuario;
    }
    if (this.tabelas.length > 0) {
      this.form.controls.tabela.setValue(this.tabelas[0].id);
    }
  }

  typeaheadNoResults(event: boolean): void {
    this.noResult = event;
  }

  ngOnInit() {
    this.filialValueSub = this.form
      .get("filial")
      ?.valueChanges.pipe(
        distinctUntilChanged(),
        filter(() => !this.aplicandoDadosCliente)
      )
      .subscribe((id) => {
        this.selecionaFilial(id);
      });

    if (this.initProvider.inicializaPedido) {
      this.toastService.warning("Usuário sem permissão para criar pedido", "Pedido")
      this.router.navigate(["/"]);
    }
    if (localStorage.getItem("tipoUsuario") === "PAINEL") {
      this.location.back();
    }
    if (!this.isCopy) {
      if (
        !this.pedidoService.confirmaAbandonarPedidoEmAberto()) {
        this.location.back();
      }
    } else {
      if (this.pedidoService.pedidoCopy === undefined) {
        this.router.navigate(["/pedidos"]);
      }
      this.usuarioService.getClientesId(
        {
          id_cliente: this.pedidoService.pedidoCopy.clientes[this.pedidoService.index].cliente.id,
          id_usuario: this.initProvider.usuario.id,
        },
        (resp) => {
          this.errorClienteBloqueado = resp.bloqueiaPedidos;
          if (resp.bloqueiaPedidos) {
            this.erroMensagemBloqueio = resp.mensagemBloqueio
          }
          this.usuarioService.getPedidoTipos(
            function (resp) {
              this.pedidoTiposUsuario = resp;
              if (this.pedidoTiposUsuario.length == 1) {
                this.form.controls.pedidoTipo.setValue(
                  this.pedidoTiposUsuario[0].id
                );
              } else {
                this.form.controls.pedidoTipo.setValue(this.pedidoService.pedidoCopy.tipo.id);
                this.tipoSelecionado = this.pedidoService.pedidoCopy.tipo.id
              }
            }.bind(this)
          );
          // this.tabelasCliente = resp[0].fn_cliente_id.content[0].tabela_preco.filter((f) => f.ativo);
          this.filiais = resp.filiais;
          this.filial_Estoque = resp.filial_estoque;
          this.setSelectedCliente(resp);
          this.addCliente(resp);

          this.selectedCliente = this.pedidoService.pedidoCopy.clientes[0].cliente;
          const filialCopyId = this.pedidoService.pedidoCopy.filial.id;
          const tabelaCopyId = this.pedidoService.pedidoCopy.tabela.id;
          this.form.controls["filial"].setValue(filialCopyId, {
            emitEvent: false,
          });
          this.form.controls.pedidoTipo.setValue(this.pedidoService.pedidoCopy.tipo.id);
          this.addCliente(this.pedidoService.pedidoCopy.clientes[0].cliente);
          this.carregarTabelasPreco(resp.id, filialCopyId, tabelaCopyId);
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.filialValueSub?.unsubscribe();
  }
}
